var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('centered',{attrs:{"brand":"","links":""}},[_c('login-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }